export function formatText1(text) {
  if (!text) return "";

  // Convert special characters to HTML-safe format
  let formatted = text
    .replace(/\n/g, "<br/>") // Convert line breaks to <br/>
    .replace(/  /g, "&nbsp;&nbsp;"); // Preserve double spaces

  return formatted;
}

export function convertTermsToHtml(raw) {
  // 1) Replace *text* with <strong>text</strong>
  //    - ([^*\n]+?) ensures we don't match across newlines or consume extra asterisks.
  //    - global flag to replace all occurrences.
  const bolded = raw.replace(/\*([^*\n]+?)\*/g, "<strong>$1</strong>");

  // 2) Replace line breaks with <br/>
  const html = bolded.replace(/\r?\n/g, "<br/>");

  // Optional: collapse multiple consecutive <br/> into two (preserve paragraph spacing)
  // html = html.replace(/(<br\/>){3,}/g, '<br/><br/>');

  return html;
}

export function formatDuration(seconds) {
  const minute = 60;
  const hour = 60 * minute;
  const day = 24 * hour;
  const month = 30 * day; // approximate month as 30 days

  if (seconds < minute) {
    return `${seconds} sec`;
  } else if (seconds < hour) {
    const m = Math.floor(seconds / minute);
    const s = seconds % minute;
    return s ? `${m} min ${s} sec` : `${m} min`;
  } else if (seconds < day) {
    const h = Math.floor(seconds / hour);
    const m = Math.floor((seconds % hour) / minute);
    return m ? `${h} hr ${m} min` : `${h} hr`;
  } else if (seconds < month) {
    const d = Math.floor(seconds / day);
    const h = Math.floor((seconds % day) / hour);
    return h ? `${d} day ${h} hr` : `${d} day`;
  } else {
    const mo = Math.floor(seconds / month);
    const d = Math.floor((seconds % month) / day);
    return d ? `${mo} month ${d} day` : `${mo} month`;
  }
}
